import {COUNTRY_CODE_PATTERN, SMS_COUNTRY_FALLBACK_SENDER_ID_PATTERN, SMS_SENDER_ID_PATTERN} from "@calendall/shared";

const senderIdPattern = new RegExp(SMS_SENDER_ID_PATTERN);
const countryFallbackSenderIdPattern = new RegExp(SMS_COUNTRY_FALLBACK_SENDER_ID_PATTERN);
const countryCodePattern = new RegExp(COUNTRY_CODE_PATTERN);

/** Mirrors the backend rule so admins see the problem before saving; the backend stays authoritative. */
export function isValidSenderId(value: string): boolean {
    return senderIdPattern.test(value);
}

/** Country fallbacks may also be a phone number in international format without `+`. */
export function isValidCountryFallbackSenderId(value: string): boolean {
    return countryFallbackSenderIdPattern.test(value);
}

/** Shape check only; the backend additionally rejects codes that are not assigned to a country. */
export function isValidCountryCode(value: string): boolean {
    return countryCodePattern.test(value);
}
